module.exports = __webpack_public_path__ + "img/successful-dispatching-icon.8ddc8ed1.png";